<template>
  <b-card
    :bg-variant="isErpActive(erp) ? '' : 'light'"
    :class="`
      ${isErpActive(erp) ? '' : 'text-secondary'}
      ${isErpActive(erp) ? 'c-pointer' : ''}
    `"
    @click="$emit('select', erp)"
  >
    <b-card-text class="d-flex align-items-center" style="gap: 1rem">
      <b-checkbox
        :disabled="!isErpActive(erp)"
        :checked="isSelected"
        @click="$emit('select', erp)"
      ></b-checkbox>

      <div>
        <b-img :src="erp.logo" height="20px" class="mr-1" />
        <span>
          {{ erp.name }}
        </span>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import EnabledIntegrationStatus from 'Enums/Integration/EnabledIntegrationStatus';

export default {
  name: 'ERPSelectCard',
  emits: ['select'],
  props: {
    erp: {
      type: Object,
      required: true,
    },
    selectedErp: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSelected() {
      return this.selectedErp.id === this.erp.id;
    },
  },
  data() {
    return {
      EnabledIntegrationStatus,
    };
  },
  methods: {
    isErpActive(erp) {
      return (
        erp.enabledIntegration &&
        erp.enabledIntegration.status ===
          EnabledIntegrationStatus.ACTIVE
      );
    },
  },
};
</script>
